// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"241":"f6ee453388eabff4","4009":"379df58457f3f103","9658":"9f14c81faf2a951a"}[chunkId] + ".css";
};